module.exports = __webpack_public_path__ + "static/r-7f796620f45517851ea1978bfa7bfa93.png";